import React, { useState, useEffect } from 'react'
import { Button, Tag } from 'antd'
import { Moment } from '../../helpers'
import { Config } from '../../config'
export const JobDueDate = (props) => {
  const showDateFromNow = (record) => {
    if (
      record.diffFromNow > 0 &&
      (record.job_status == 1 || record.job_status == 2)
    ) {
      return (
        <Tag color={Config.job.dateDiffColor['future']}>
          อีก {record.diffFromNow} วัน
        </Tag>
      )
    } else if (
      record.diffFromNow < 0 &&
      (record.job_status == 1 || record.job_status == 2)
    ) {
      return (
        <Tag color={Config.job.dateDiffColor['past']}>
          เลยแล้ว {record.diffFromNow} วัน
        </Tag>
      )
    } else if (
      record.diffFromNow == 0 &&
      (record.job_status == 1 || record.job_status == 2)
    ) {
      return <Tag color={Config.job.dateDiffColor['today']}>วันนี้</Tag>
    }
  }

  return <React.Fragment>{showDateFromNow(props.data)}</React.Fragment>
}
